"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _common = require("@insided/shared/utils/common");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dateFormatDestination = _interopRequireDefault(require("../utils/dateFormatDestination"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var PostAuthorMeta = function PostAuthorMeta(props) {
  var _ref2, _ref3;

  var replyUser = props.replyUser,
      displayAuthor = props.displayAuthor,
      repliedAt = props.repliedAt,
      isBestAnswer = props.isBestAnswer,
      replyCount = props.replyCount;

  var _ref = replyUser || {},
      reputation = _ref.reputation,
      userTitle = _ref.userTitle;

  var rank = replyUser.rank;
  var userRankTitle = (_ref2 = userTitle !== null && userTitle !== void 0 ? userTitle : reputation === null || reputation === void 0 ? void 0 : reputation.rank) !== null && _ref2 !== void 0 ? _ref2 : '';
  var replyTime = new Date(repliedAt).getTime();
  var repliesMade = (_ref3 = replyCount !== null && replyCount !== void 0 ? replyCount : reputation === null || reputation === void 0 ? void 0 : reputation.repliesMade) !== null && _ref3 !== void 0 ? _ref3 : 0;
  return (0, _preact.h)("div", {
    className: "post__user__meta"
  }, (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta')
  }, (0, _preact.h)("li", null, (0, _preact.h)("div", {
    className: "group--inline"
  }, (0, _preact.h)(_UserName.default, {
    user: replyUser,
    extraClass: "username"
  }), (rank === null || rank === void 0 ? void 0 : rank.iconUrl) && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(rank.iconUrl),
    className: "usericon qa-latest-poster-usericon",
    alt: rank === null || rank === void 0 ? void 0 : rank.name
  }))), displayAuthor ? (0, _preact.h)("li", {
    className: "list-item--no-dot"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('pill', 'pill--author', 'pill--uppercase', 'pill--inline')
  }, (0, _preact.h)(_phrase.default, {
    p: "Author"
  }))) : null, userRankTitle && (0, _preact.h)("li", {
    className: "list-item--no-dot is-hidden-S"
  }, (0, _preact.h)("span", {
    title: userRankTitle,
    className: (0, _classnames.default)('usertitle qa-usertitle')
  }, userRankTitle)), (0, _preact.h)("li", {
    className: "is-hidden-S"
  }, (0, _preact.h)(_phrase.default, {
    p: "topic.meta.post.reply",
    count: {
      n: repliesMade.toString()
    }
  })), isBestAnswer && (0, _preact.h)("li", {
    className: "list-item--no-dot-S"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('pill', 'pill--answer', 'pill--uppercase', 'pill--inline')
  }, (0, _preact.h)(_phrase.default, {
    p: "Answer"
  }))), (0, _preact.h)("li", {
    className: (0, _classnames.default)('list-item--float-right', 'list-item--no-dot', 'list-item--publish-date')
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("time", null, " ", _common.common.relativeDate(replyTime), " "),
    tooltipMessage: (0, _preact.h)("div", {
      className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content', 'position--bottom')
    }, (0, _dateFormatDestination.default)(replyTime))
  }))));
};

var _default = PostAuthorMeta;
exports.default = _default;